import './Loading.scss';
const { Icon } = require('@paymongo/seeds');

interface isLoading {
  loading: boolean;
  children: JSX.Element;
}

const Loading = ({ loading, children }: isLoading) => {
  return (
    <div className={ `loading ${loading && 'loading--active'}`}>
      <Icon icon="spinner" pulse="true" className="loading__spinner" size="lg" spin="true" />
      <div className='loading__content'>
        {children}
      </div>
    </div>
  );
}

export default Loading;
